export default __webpack_public_path__ + "8f22e0e801a1fed3ed2c6d244c556694.svg";